<template>
  <div>
    <v-container v-if="!cargando">
      <v-row dense>
        <v-col sm="5" md="5" lg="5" xl="5">
          <v-btn v-if="getIdPrevPage !== ''" color="btncolor" small right text @click="volver()" dark>
            <v-icon left small dark>fas fa-reply</v-icon>
            <span class="font-weight-bold title">Volver</span>
          </v-btn>
        </v-col>
        <v-col sm="4" md="4" lg="4" xl="4">
          <v-btn width="185%" right text small color="btncolor" @click="printSection()" dark> 
            <span class="font-weight-bold title">Exportar</span> 
            <v-icon small right dark>fa-chevron-right</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
    <div id="printPage">
      <v-container v-if="!cargando">
        <div class="imprimir">
          <v-row dense>
            <v-col sm="12" md="12" lg="12" xl="12">
              <h3 id="titleForm" class="text-center">
                FORMULARIO No. {{ $route.params.id }} - {{ aHeader.Titulo }}
              </h3>
            </v-col>
          </v-row>
          <v-row justify="center" dense>
            <v-col sm="12" md="4" lg="4" xl="4">
              <div id="sImgReference" style="border: 1px; text-align: center;">
                <img id="Logo" style="width: 200px;" :src="LogoImageURL"/>
              </div>
            </v-col>
            <v-col sm="12" md="4" lg="4" xl="4">
              <div>
                <span class="font-weight-bold h4 text-uppercase">Usuario Gestor</span>
                <p class="text-capitalize">{{ aHeader.Usuario }}</p>
              </div>
            </v-col>
            <v-col sm="12" md="4" lg="4" xl="4">
              <div>
                <span class="font-weight-bold h4 text-uppercase">Fecha Elaboración</span>
                <p class="text-capitalize">{{ aHeader.Fecha }}</p>
              </div>
            </v-col>
          </v-row>
        </div>
        <v-row justify="center" align="center" dense>
          <v-col sm="12" md="12" lg="12" xl="12">
            <v-card v-for="(oData, i) in aData" :key="i" class="imprimir"
              outlined>
              <Bloques
                :title="oData.BannerTitle">
              </Bloques>
              <div v-for="(aata, j) in oData" :key="j">
                <br>
                <div v-for="(otros, k) in aata" :key="k">
                  <component :is="otros.TipoPregunta"
                    :aItems="aata"
                    :nIndex="k">
                  </component>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>
<script>
import axiosServices from '@/services/axiosServices.js'
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf'
import Bloques from '@/components/FormDinamicos/Componentes/Bloque.vue'
import RespuestaSencilla from '@/components/FormDinamicos/Componentes/RespuestaSencilla.vue'
import Foto from '@/components/FormDinamicos/Componentes/Foto.vue'
import Firma from '@/components/FormDinamicos/Componentes/Firma.vue'
import MultiSelect from '@/components/FormDinamicos/Componentes/Multiselect.vue'
import Correo from '@/components/FormDinamicos/Componentes/Correo.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'FormDic',
  components: {
    Bloques,
    RespuestaSencilla,
    Foto,
    Firma,
    MultiSelect,
    Correo
  },
  data () {
    return {
      cargando: false,
      LogoImageURL: '',
      aHeader: [],
      aData: []
    }
  },
  mounted () {
    this.getLogo()
    this.getHeader()
    this.getOrderData()
  },
  methods: {
    getLogo () {
      this.cargando = true
      let sParams = 'sPath=LogoImagen'
      axiosServices.getConfiguration('FormDinamic_Path', false, sParams).then(getPath => {
        this.LogoImageURL = getPath.aData.Observacion
        this.proccessData()
      })
    },
    getHeader () {
      this.cargando = true
      // let sParams = 'sDetails='+ this.sNameDetails
      axiosServices.getConfiguration(`FormDinamic_Header/${this.$route.params.id}`, false, '').then(getHeader => {
        this.aHeader = getHeader.aData
      })
    },
    getOrderData () {
      axiosServices.getConfiguration(`FormDinamic_Body/${this.$route.params.id}`, false, '').then(getBody => {
        this.aData = getBody.aData
        this.cargando = false
      })
    },
    async printSection() {
      let elements = document.querySelectorAll("#printPage .imprimir")
      var doc = new jsPDF('p', 'mm', 'a4', true)
      doc.setFillColor(245);
      doc.rect(0, 0, 210, 700, "F");
      var imgWidth = doc.internal.pageSize.getWidth()
      var pageHeight = doc.internal.pageSize.getHeight()
      var position = 10
      var pageHeightLeft = pageHeight;
      for (let i = 0; i < elements.length; i++) {
        await html2canvas(elements[i], {
          scale: 2,
          useCORS: true,
          allowTaint: true
        }).then(function(canvas) {
          let imgData = canvas.toDataURL('image/png', 1.0)
          var imgHeight = canvas.height * imgWidth / canvas.width
          // Comprobamos salto
          if (pageHeightLeft - imgHeight <= 0) {
            doc.addPage();
            pageHeightLeft = pageHeight
            position = 10; // Pintaremos en el inicio de la nueva pagina
          }
          doc.addImage(imgData, 'PNG', 0, position, (imgWidth - 2), imgHeight)
          position += imgHeight; // Marcamos el siguiente inicio
          pageHeightLeft -= imgHeight; // Marcamos cuanto espacio nos queda
        })
      }
      doc.save(`${document.getElementById('titleForm').textContent}.pdf`)
    },
    toDataURL (src, callback) {
      var img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function() {
        var canvas = document.createElement('canvas')
        var context = canvas.getContext('2d')
        canvas.height = this.naturalHeight
        canvas.width = this.naturalWidth
        context.drawImage(this, 0, 0)
        var dataURL = canvas.toDataURL('image/jpeg', 1.0)
        callback(dataURL)
      }
      img.src = src
    },
    proccessData () {
      this.toDataURL(`${this.sLogoImg}`, this.setValue)
    },
    setValue (sBase64) {
      this.LogoImageURL = sBase64
    },
    resize () {
      if (window.addEventListener) {  // all browsers except IE before version 9
        window.addEventListener("resize", onResizeEvent, true);
      }
      function onResizeEvent() {
        let divImgElement = document.getElementById("sImgReference")
        let newWidth = divImgElement.clientWidth
        let oImgRender = document.getElementById("Logo")
        oImgRender.style.width = `${newWidth}px`
      }
    },
    volver() {
      this.$router.replace({path : `/GridDinamicosNew/${this.getIdPrevPage}`})
    }
  },
  computed: {
    ...mapGetters(['getIdPrevPage'])
  },
}
</script>